import script from "./TcMarkdownRendered.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TcMarkdownRendered.vue?vue&type=script&setup=true&lang=ts"
export * from "./TcMarkdownRendered.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TcMarkdownRendered.vue?vue&type=script&setup=true&lang=ts"

import "./TcMarkdownRendered.vue.scss?vue&type=style&index=0&id=002ce586&lang=scss!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./TcMarkdownRendered.vue?vue&type=style&index=0&id=002ce586&lang=scss"

const __exports__ = script;

export default __exports__